<div class="ifram-container">
    <iframe
        [attr.src]="data.contact.mapURL | urlSanitizer"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
    ></iframe>
</div>
